/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { InfoItem, RelatedContentModal, CountryField } from '@molecules';
import { NO_MARGIN_BOTTOM } from '@constants';

const RelatedCountriesModal = ({ visible, hide, onSubmit }) => (
  <RelatedContentModal
    visible={visible}
    hide={hide}
    title="Add related country"
    subtitle="Find a country related to this article"
    okText="ADD COUNTRY"
    onSubmit={({ country }) => onSubmit(country)}
  >
    <CountryField
      label="Choose a country:"
      name="country"
      extra={null}
      wrapperCol={{ span: 24 }}
      style={NO_MARGIN_BOTTOM}
      rules={[{ required: true, message: 'Country is required' }]}
    />
  </RelatedContentModal>
);

const Item = (country) => <InfoItem>{country.name}</InfoItem>;

RelatedCountriesModal.Item = Item;

export default RelatedCountriesModal;
